export default "__VITE_ASSET__CvGQJMc6__"